var mobileCheckInService = function (apiService, $q) {

    var categories;
    var mcCategory;
    var mcCategoryTag;
    var self = this;

    apiService.onInit()
        .then(function () {
            apiService.getCatalog()
                .then(function (catalog) {
                    return catalog.getServiceCategoryCollection()
                })
                .then(function (data) {
                    categories = data.categories;
                    self.getMobileCheckinCategoryTag()
                    console.log('mobile checkin category tag =', mcCategoryTag);
                })
        })

    this.getMobileCheckinCategory = function (force) {
        if (mcCategory && !force) return mcCategory;
        mcCategory = _.filter(categories, function (c) {
            return c.categoryId.toLowerCase() === ('Mobile Check-In').toLowerCase();
        })[0];
    }

    this.getMobileCheckinCategoryTag = function (force) {
        if (mcCategoryTag && !force) return mcCategoryTag;
        var cat = this.getMobileCheckinCategory(force);
        if (cat) {
            mcCategoryTag = _.get(cat, 'tags.items[0].value');
        }
    }

    this.isMobileCheckInService = function (service) {
        var cat = self.getMobileCheckinCategory();
        if (!cat) return false;
        try {
            const rel = 'http://api.dealer-fx.com/docs/rels/maintenance-service-category';
            const cHref = _.get(_.find(cat.links, {rel: rel}), 'href');
            const sHref = _.get(_.find(service.links, {rel: rel}), 'href');
            return cHref && sHref && cHref === sHref;
        } catch (e) {}
    }
}
mobileCheckInService.$inject = ['apiService', '$q'];

module.exports = mobileCheckInService;
